import Portfolio from "../Portfolio/Portfolio";

function Portraits() {
  return <Portfolio canonicalPath="/portfolio" />;
}

export default Portraits;
